// src/components/Footer/Footer.js (SEM MUDANÇAS AQUI)
import React from 'react';
import './Footer.css';
import dlogicFooterLogo from '../../assets/logo (2).png';
import githubIcon from '../../assets/github.svg';
import linkedinIcon from '../../assets/linkedin.svg';


function Footer() {
  const teamMembers = [
    {
      name: 'Enzo Previtale',
      github: 'https://github.com/EnzoPrevitaale',
      linkedin: 'https://linkedin.com/in/enzo-gabriel-previtale-silva',
    },
    {
      name: 'Heloisa Militão',
      github: 'https://github.com/helomsz',
      linkedin: 'https://linkedin.com/in/heloisa-militão-de-souza',
    },
    {
      name: 'Isadora Abreu',
      github: 'https://github.com/IsadoraAbreuu',
      linkedin: 'https://linkedin.com/in/isadora-abreu',
    },
    {
      name: 'Luiza Gonçalves',
      github: 'https://github.com/Luizasantoscreator',
      linkedin: 'https://linkedin.com/in/luiza-goncalves',
    },
  ];

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-top">
          <div className="footer-brand-slogan">
            <div className="footer-brand">
              <img src={dlogicFooterLogo} alt="DLOGIC Logo" className="footer-logo" />
              <div className="footer-slogan">
                <p>"Precisão no cálculo. Eficiência na organização"</p>
              </div>
            </div>
          </div>
          


          
          <div className="footer-team-links">
            {teamMembers.map((member, index) => (
              <div className="team-member-column" key={index}>
                <h3>{member.name}</h3>
                <a href={member.github} target="_blank" rel="noopener noreferrer">
                  <img src={githubIcon} alt="GitHub" className="social-icon" /> {member.github.split('/').pop()}
                </a>
                <a href={member.linkedin} target="_blank" rel="noopener noreferrer">
                  <img src={linkedinIcon} alt="LinkedIn" className="social-icon" /> {member.linkedin.split('/').pop()}
                </a>
              </div>
            ))}
          </div>
        </div>

        <div className="footer-divider"></div>

        <div className="footer-bottom">
          <p className="copyright">
            Copyright © 2025 | DLOGIC Company
          </p>
          <div className="footer-links">
            <a href="#terms">Terms and Conditions</a>
            <a href="#privacy">Privacy Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
